import { Link } from 'react-router-dom';
import { Theme, styled } from '@mui/material';

export const topBannerIconStyle = { width: '20px', height: '20px' };

export const topBannerContainerStyles = {
  alignItems: 'center',
  width: '100%',
  height: '40px',
  p: 2,
  wordBreak: 'break-all',
};

export const alertContainerStyle = {
  background: 'transparent',
  boxShadow: 'none',
  padding: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'end',
};

export const modalActionBlockStyles = {
  padding: 3,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTop: '1px solid #00000033',
};

export const modalHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 3,
  py: 2,
};

export const modalWidthStyles = {
  width: {
    md: '900px',
    sm: '90vw',
    xs: '90vw',
  },
};

export const modalSmallWidthStyles = {
  width: {
    md: '500px',
    sm: '90vw',
    xs: '90vw',
  },
};

export const navigationDrawerStyles = (isDrawerOpen: boolean) => ({
  width: isDrawerOpen ? 240 : '7rem',
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: isDrawerOpen ? 240 : '7rem',
    minWidth: 35,
    overflowX: 'hidden',
    position: 'relative',
  },
});

export const listNavigationItemStyles = {
  '& a': {
    textDecoration: 'none !important',
    width: '100%',
  },
  '& .MuiListItemButton-root': {
    borderLeft: '0.4rem solid',
    borderColor: 'transparent',

    '& .MuiListItemText-primary': {
      fontSize: '1.6rem',
      color: '#140f4b',
    },
    '& .MuiListItemIcon-root': {
      color: 'primary.main',

      '& svg': {
        width: '2.4rem',
        height: '2.4rem',
      },
    },
  },
  '& .active .MuiListItemButton-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderColor: 'electricBlue.main',

    '& .MuiListItemText-primary': {
      color: 'electricBlue.main',
    },
    '& .MuiListItemIcon-root': {
      color: 'electricBlue.main',
    },
  },
};

export const listNavigationButtonStyles = {
  padding: '8px 2.5rem 8px 1.5rem',
  height: '5.2rem',
  minHeight: 35,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};

export const fileUploaderContainerStyles = (dragActive: boolean, isFilesUploaded: boolean) => ({
  display: 'flex',
  flexDirection: isFilesUploaded ? 'row' : 'column',
  justifyContent: 'center',
  gap: 1.5,
  px: isFilesUploaded ? 1 : 3,
  py: isFilesUploaded ? 2 : 6,
  textAlign: 'center',
  border: '4px dashed',
  borderColor: dragActive ? 'primary.main' : '#0000004D',
  backgroundColor: dragActive ? 'electricBlue10.main' : '#F5F5F5',
  transition: (t: Theme) => t.transitions.create(['border-color', 'background-color'], { duration: 150 }),
  cursor: 'pointer',
  alignItems: 'center',
  flex: 1,
});

export const fileListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  minHeight: '100px',
  maxHeight: '250px',
  overflowY: 'auto',
};

export const fileListItemStyles = {
  p: 2,
  borderRadius: '8px',
  border: '1px solid #0000004D',
};

export const StyledLink = styled(Link)<{ to?: string }>(({ to }) => ({
  textDecoration: 'none',
  color: 'rgba(0, 0, 0, 0.6)',
  cursor: to ? 'pointer' : 'default',
  display: 'flex',
  lineHeight: '2rem',
  height: '2rem',
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
}));

export const modalContainerHeight = '95vh';

export const modalOverflowBoxStyles = {
  display: 'flex',
  p: 3,
  maxHeight: `calc(${modalContainerHeight} - 290px)`,
  overflowY: 'auto',
};

export const modalContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '0.8rem',
  maxHeight: modalContainerHeight,
  bgcolor: '#ffffff',
  ...modalWidthStyles,
};

export const modalSmallContainerStyle = {
  ...modalContainerStyle,
  ...modalSmallWidthStyles,
};

export const searchTextFieldStyles = {
  borderRadius: 24,

  '& fieldset': {
    border: '1px solid #0000004D',
    borderRadius: 24,
  },
  '& .MuiOutlinedInput-root': {
    height: 35,
    px: '18px',
    borderRadius: 24,
    backgroundColor: '#fff',

    '& .MuiInputAdornment-root': {
      mr: 0,
    },

    '& .MuiOutlinedInput-input': {
      p: 0,
      pl: '8px',
    },

    '&.Mui-focused, :hover': {
      '& fieldset': {
        border: '1px solid #1010EB',
      },
      '& .MuiInputAdornment-root': {
        ' svg': {
          color: '#1010EB',
        },
      },
    },
    '&.Mui-disabled': {
      opacity: 0.5,

      '&:hover': {
        '& fieldset': {
          border: '1px solid #0000004D',
        },
      },
    },
  },
};

export const layoutStyles = {
  margin: '2rem',
  width: { xl: '80vw', lg: '90vw', md: '90vw', sm: '90vw' },
  maxWidth: '1300px',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  minHeight: '100%',
};

export const feedbackButtonsBlockStyles = {
  mt: 'auto',
  pt: '4rem',
  mb: '4rem',
  display: 'flex',
  justifyContent: 'center',
  gap: 3,
};

export const feedbackButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
};

export const regionSelectorContainerStyles = {
  position: 'fixed',
  top: 9.5,
  alignItems: 'center',
};

export const regionOptionsListStyles = {
  listItemSx: {
    margin: '1rem -3rem',
  },
  linkSx: {
    display: 'flex',
    gap: '3rem',
    flexDirection: 'row-reverse',

    '& span': {
      marginRight: 0,
    },
  },
};

export const tableActionButtonStyles = {
  color: 'electricBlue.main',
  textTransform: 'capitalize',
};

export const pageContainerStyles = {
  flex: 1,
  minWidth: 0,

  '& > [data-testid="inner-container"]': {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
  },
};

export const pageContainerInlineStyles = {
  height: '100%',
  maxWidth: '100%',
  marginLeft: 0,
  overflowX: 'hidden',
};

export const pageContainerWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100dvh',
  overflow: 'hidden',
};
